// extracted by css-extract-rspack-plugin
export default {"ConfirmIdentityBanner":"sputnik__ConfirmIdentityBanner__srN9V","confirmIdentityBanner":"sputnik__ConfirmIdentityBanner__srN9V"};